import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';

@Component({
  selector: 'app-accounts-list-transfer',
  templateUrl: './../../../templates/forms/modals/accounts-list-transfer.component.html',
})
export class AccountsListTransferComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  accountsListModalExtarnalValue;

  @Input()
  BU_NO;

  @Input()
  ACC_NO;

  @Input()
  PERIOD_NO;
  
  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  chartOfAccountList: any[] = [];
  searchFields: any[] = ['ACC_NAME', 'ACC_NO'];
  public searchString;

  constructor(public langService: LangService, private dataService: CommonService) { }

  ngOnInit() {
    this.dataService.getChartOfAccounts(this.accountsListModalExtarnalValue,0,this.PERIOD_NO, this.BU_NO, this.ACC_NO)
    .subscribe(arg => { 
      this.chartOfAccountList = arg.body 
      console.log("account List ", arg.body );
    });
  }
}
